import { isUndefined, isNull } from 'lodash-es';

const checkValidEmail = email =>
  /@(lynked\.co\.jp|tabilife\.co\.jp)$/.test(email);
const checkValidLynkedUser = user => {
  /**
   * return true when valid user found
   */
  if (isUndefined(user)) return false;
  if (isNull(user)) return false;
  if (!checkValidEmail(user.email)) return false;

  return true;
};

export { checkValidLynkedUser };
